import { render, staticRenderFns } from "./HistoricVor.vue?vue&type=template&id=d4b805b2&scoped=true"
import script from "./HistoricVor.vue?vue&type=script&lang=js"
export * from "./HistoricVor.vue?vue&type=script&lang=js"
import style0 from "./HistoricVor.vue?vue&type=style&index=0&id=d4b805b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b805b2",
  null
  
)

export default component.exports